<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="anote"><span class="epub-b">AUTHOR’S NOTE</span></p>
<p class="fmtni">Andrew Cunanan, the man whose life is described in this book, fits the commonly used definition of a spree killer because he was engaged full-time in the business of killing one person after another.</p>
<p class="fmtx">“Spree killers are a type of serial killer who are involved on a full-time basis in their killings and in running from the law,” says James Alan Fox, dean of the college of criminal justice at Northeastern University.</p>
<p class="fmtx">Ordinary serial killers, by contrast, says Professor Fox, may have jobs and families and take time out between their murders.</p>
<p class="fmtx">Some experts believe that a spree or serial killer must claim three victims before being given the appellation, but Professor Fox believes that four is a more accurate figure.</p>
<p class="fmtx">Cunanan was forever inventing fictional personas for himself. I have pieced together the story of his life in part from what he told friends about himself and his family. But how much was reality and how much was his invention is, of course, difficult to know. But fact or fantasy, it all is essential to understanding who Cunanan was.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// authornote.vue?6c2f3d07